import * as React from 'react';
import {
  Component,
  Handler,
  getRandomKey,
  isNullOrEmpty,
  I18NString,
  numberCommaToDot,
  numberDotToComma,
  parseFloatCommaDot,
  strCommaToDot,
} from '../../Utils';
import { ButtonGroup } from 'react-bootstrap';
import { IControlError, IControlSchema } from '../../Controls';
import { IDispatcher } from '../extensions/Dispatcher';
import { isEmpty, isUndefined, findIndex, filter, isNumber } from 'lodash';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import Field from '../Field';
import { Button, Alert } from 'react-bootstrap';

interface FixedTableColumn {
  type?: any;
  title: I18NString;
  name: string;
  isKey: boolean;
  order: number;
  placeholder?: I18NString;
}

interface FixedTableCell {
  name: string;
  type: string;
  value: I18NString;
}

interface FixedTableRow {
  order: number;
  parent?: any;
  internal_id?: any;
  data: Array<FixedTableCell>;
  type?: string;
}

interface FixedTableSchema extends IControlSchema {
  columns: Array<FixedTableColumn>;
  rows: Array<FixedTableRow>;
  disabled?: boolean;
  value?: Array<any>;
  description?: I18NString;
}

interface IFixedTableProps {
  schema: FixedTableSchema;
  dispatcher?: IDispatcher;
  error: IControlError | undefined;
  visited: boolean;
}

interface IFixedTableState {
  selectRow: object;
  values: Array<any>;
  showHelp: boolean;
  empty: boolean;
}

const emptyChecker = (value, row, rowIndex, formatExtraData) =>
  !value
    ? formatExtraData.columnType != 'label' &&
      row[formatExtraData.dataField + '_type'] != 'label' &&
      row[formatExtraData.dataField + '_type'] != 'children_sum'
      ? formatExtraData.placeholder
      : ''
    : value;

class FixedTable extends Component<IFixedTableProps, IFixedTableState> {
  constructor(props) {
    super(props);

    this.state = {
      selectRow: {},
      values: [],
      showHelp: false,
      empty: true,
    };
    this.isCellEditable = this.isCellEditable.bind(this);
    this.getColumnsSorted = this.getColumnsSorted.bind(this);
    this.getRowsSorted = this.getRowsSorted.bind(this);
    this.getCell = this.getCell.bind(this);
    this.validateCell = this.validateCell.bind(this);
    this.findKeyField = this.findKeyField.bind(this);
    this.afterSaveCell = this.afterSaveCell.bind(this);
    this.updateParentCells = this.updateParentCells.bind(this);
    this.helpClick = this.helpClick.bind(this);
  }
  getColumnsSorted() {
    return this.props.schema.columns.sort(
      (c1: FixedTableColumn, c2: FixedTableColumn) => {
        if (c1.order < c2.order) return -1;
        if (c1.order > c2.order) return 1;
        return 0;
      },
    );
  }
  getRowsSorted() {
    return this.props.schema.rows.sort(
      (r1: FixedTableRow, r2: FixedTableRow) => {
        if (r1.order < r2.order) return -1;
        if (r1.order > r2.order) return 1;
        return 0;
      },
    );
  }
  getCell(rowIndex, colIndex) {
    /*
     * проверка индексов?
     */
    var row = this.getRowsSorted()[rowIndex];
    return row.data[colIndex];
  }
  helpClick() {
    this.setState({ showHelp: !this.state.showHelp });
  }
  render() {
    const {
      schema: { disabled, visible, columns },
      error,
    } = this.props;

    const errorMessage = error && error.message;

    const config = {
      insertRow: false,
      deleteRow: false,
      options: {
        noDataText: 'Нет данных для отображения',
      },
    };
    let customCell = (cell, row) => <span title={cell}>{cell}</span>;
    return isUndefined(visible) || visible ? (
      <Field
        {...this.props.schema}
        status={this.state.empty ? 'default' : 'success'}
      >
        {
          <BootstrapTable
            keyField={this.findKeyField()}
            cellEdit={cellEditFactory({
              mode: 'click',
              blurToSave: true,
              afterSaveCell: this.afterSaveCell,
            })}
            rowClasses={(row, rowIndex) => {
              for (
                var columnIndex = 0;
                columnIndex < columns.length;
                columnIndex++
              ) {
                if (this.isCellEditable(rowIndex, columnIndex)) {
                  return '';
                }
              }
              return 'row-disabled';
            }}
            bodyClasses="react-bs-container-body_fixed_table"
            data={this.state.values}
            columns={this.getColumnsSorted().map(
              (column: FixedTableColumn, idx: number) => {
                return {
                  hidden: false,
                  isKey: column.isKey,
                  dataField: column.name,
                  editable: (cell, row, rowIndex, colIndex) => {
                    if (disabled) return false;
                    return this.isCellEditable(rowIndex, colIndex);
                  },
                  validator: (newValue, row, column) => {
                    return this.validateCell(newValue, row, column);
                  },
                  formatter: emptyChecker,
                  formatExtraData: {
                    placeholder: column.placeholder
                      ? this.tr(column.placeholder)
                      : '',
                    dataField: column.name,
                    columnType: column.type,
                  },
                  text:
                    column.title && column.title.ru
                      ? column.title.ru
                      : column.type,
                };
              },
            )}
          ></BootstrapTable>
        }
        <ButtonGroup>
          {!isUndefined(this.props.schema.description) && (
            <Button
              onClick={this.helpClick}
              bsStyle="primary"
              title="Справка"
              className="btn btn-default btn-circle"
            >
              <span className="glyphicon glyphicon-question-sign"></span>
            </Button>
          )}
        </ButtonGroup>
        {errorMessage && <Alert bsStyle="danger">{errorMessage}</Alert>}
        {this.state.showHelp && (
          <Alert bsStyle="warning">
            <div
              dangerouslySetInnerHTML={{
                __html:
                  this.props.schema.description &&
                  this.tr(this.props.schema.description),
              }}
            ></div>{' '}
          </Alert>
        )}
      </Field>
    ) : (
      <div></div>
    );
  }
  updateParentCells(dataField, rowDataType, rowParentId, depth, doneHandler) {
    /*
     * возможно сделать json с описанием компонента
     * так, чтобы строки ссылались друг на друга
     * в качестве родителя. ниже - защита от
     * бесконечной рекурсии. константа 50 - с потолка
     */
    if (depth >= 50) return;
    const {
      schema: { rows, columns, id },
      error,
      dispatcher,
    } = this.props;
    /*
     * нужно найти индекс столбца, с которым
     * выполняются дальнейшие действия
     */
    var column_index = 0;
    for (var c = 0; c < columns.length; c++) {
      if (columns[c].name == dataField) {
        column_index = c;
        break;
      }
    }
    var haldled = false;
    //если сейчас изменили числовое значение (или сумму)
    if (rowDataType == 'number' || rowDataType == 'children_sum') {
      //если задана родительская строка, её нужно обновить
      var parent_row = this.findRowById(rowParentId);
      if (parent_row) {
        //если родитель является суммой дочерних
        if (parent_row.data[column_index].type == 'children_sum') {
          var new_parent_val = 0;
          //перебираем дочерние с таким же родителем
          for (var r = 0; r < rows.length; r++) {
            var child_val = this.state.values[r][dataField];
            if (this.state.values[r][dataField + '_type'] == 'number') {
              child_val = numberCommaToDot(child_val);
            }
            if (
              child_val &&
              !isNaN(parseFloat(child_val)) &&
              (this.state.values[r][dataField + '_type'] == 'number' ||
                this.state.values[r][dataField + '_type'] == 'children_sum') &&
              this.state.values[r].parent == rowParentId
            ) {
              /*
               * если значение есть, если это число
               * и если родительский id совпадает,
               * то добавляем к сумме
               */
              new_parent_val += parseFloat(child_val);
            }
          }
          //теперь обновляем состояние
          var values = this.state.values.map((value, index) => {
            var rawValue = 0;
            if (value.internal_id == parent_row.internal_id) {
              rawValue = new_parent_val;
            } else {
              if (value[dataField + '_type'] == 'number') {
                rawValue = value[dataField]
                  ? parseFloatCommaDot(value[dataField])
                  : null;
              } else {
                rawValue = value[dataField];
              }
            }
            if (value[dataField + '_type'] == 'number') {
              if (rawValue != null) {
                rawValue = Math.round(rawValue * 100.0) / 100.0;
              }
              value[dataField] = numberDotToComma(
                rawValue != null ? rawValue.toString() : null,
              );
            } else {
              value[dataField] = rawValue;
            }
            return value;
          });
          haldled = true;
          this.setState(
            {
              values: values,
              empty: false,
            },
            () => {
              /*
               * изменилось значение значение parent_row
               * если у него есть parent, то его
               * содержимое тоже нужно обновить
               */
              if (parent_row.parent) {
                this.updateParentCells(
                  dataField,
                  parent_row.data[column_index].type,
                  parent_row.parent,
                  depth + 1,
                  doneHandler,
                );
              } else {
                doneHandler();
              }
            },
          );
        }
      }
    }
    if (!haldled && depth == 0) doneHandler();
  }
  afterSaveCell(oldValue, newValue, row, column) {
    const { dispatcher, schema } = this.props;
    this.updateParentCells(
      column.dataField,
      row[column.dataField + '_type'],
      row.parent,
      0,
      () => {
        dispatcher.onBlur(schema.id, this.state.values, true, undefined);
      },
    );
  }
  findRowById(row_id) {
    if (!row_id) return null;
    const {
      schema: { rows, columns },
      error,
    } = this.props;
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].internal_id == row_id) return rows[i];
    }
    return null;
  }
  findKeyField() {
    const {
      schema: { columns },
    } = this.props;
    for (var i = 0; i < columns.length; i++) {
      if (columns[i].isKey == true) return columns[i].name;
    }
    return undefined;
  }
  isCellEditable(rowIndex, colIndex) {
    /*
     * сначала проверка по столбцу.
     * если столбец типа 'label'
     * то редактировать точно нельзя
     */
    if (this.getColumnsSorted()[colIndex].type == 'label') {
      return false;
    } else {
      /*
       * на уровне столбца редактирование разрешено.
       * оно может быть запрещено на уровне строки
       * label - редактировать нельзя, метка
       * children_sum - редактировать нельзя, вычисляемое поле
       */
      var cell_type = this.getCell(rowIndex, colIndex).type;
      if (cell_type == 'label' || cell_type == 'children_sum') {
        return false;
      }
    }
    return true;
  }
  validateCell(newValue, row, column) {
    if (!newValue) return true;
    var valType = row[column.dataField + '_type'];
    if (valType == 'number') {
      if (!isNaN(parseFloat(strCommaToDot(newValue)))) return true;
      return {
        valid: false,
        message: 'Введите число',
      };
    }
    if (valType == 'text') {
      if (newValue.length == 0) {
        return {
          valid: false,
          message: 'Введите строку',
        };
      } else return true;
    }
    return {
      valid: false,
      message: 'Неизвестно',
    };
  }
  getDominatingType(colType, rowType) {
    if (colType == 'label' || !rowType) return colType;
    return rowType;
  }
  componentDidMount() {
    const {
      schema: { rows, columns, value },
      error,
    } = this.props;
    if (isUndefined(value)) {
      this.setState({
        values: this.getRowsSorted().map((row: FixedTableRow, idx: number) => {
          var res = {};
          for (var i = 0; i < row.data.length; i++) {
            var item = row.data[i];
            res[item.name] = item.value ? item.value : null;
            res[item.name + '_type'] = this.getDominatingType(
              columns[i].type,
              item.type,
            );
          }
          res['internal_id'] = row.internal_id;
          res['parent'] = row.parent;
          res['type'] = row.type;
          return res;
        }),
        empty: true,
      });
    } else {
      this.setState({
        values: typeof value === 'string' ? JSON.parse(value) : value,
        empty: false,
      });
    }
  }
}

export function createFixedTable(
  schema: IControlSchema,
  dispatcher: IDispatcher = null,
  error: IControlError | undefined,
  visited: boolean,
): React.ReactElement<any> {
  return (
    <FixedTable
      schema={schema as FixedTableSchema}
      error={error}
      visited={visited}
      dispatcher={dispatcher}
    />
  );
}
